import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=09aa7740&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=ts"
export * from "./EditButton.vue?vue&type=script&lang=ts"
import style0 from "./EditButton.vue?vue&type=style&index=0&id=09aa7740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa7740",
  null
  
)

export default component.exports